export default {
    apiUrl: 'https://api.app.cloudtsx.com',
    pdfUrl: 'https://pdf-api.app.cloudtsx.com',
    googleApiKey: 'AIzaSyBt9XxAHxFg-6cVke7aItRF4NDATE_wynM',
    trackingApi: 'https://tracking.app.cloudtsx.com',
    webSocketsUrl: 'https://ws.app.cloudtsx.com',
    chatWebSocketUrl: 'https://chat.cloudtsx.com',
}
